import { NgxBootstrapDatePickerConfigService } from 'assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
var ɵ0 = NgxBootstrapDatePickerConfigService.getDatepickerConfig, ɵ1 = NgxBootstrapDatePickerConfigService.getDaterangepickerConfig, ɵ2 = NgxBootstrapDatePickerConfigService.getDatepickerLocale;
var MyHealthcareModule = /** @class */ (function () {
    function MyHealthcareModule() {
    }
    return MyHealthcareModule;
}());
export { MyHealthcareModule };
export { ɵ0, ɵ1, ɵ2 };
